//////LIBRARY//////
import styled from 'styled-components'
import React, { useEffect, useState, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { map, isUndefined, isEmpty, isNull, find } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { itemCatalogDetailActionCreators, tableActionCreators } from '../../../store/actions'
import { usagePicsConfig } from '../../../constants/AssetsPicturesConfigList'
import Button from '../../../components/Ui/Buttons'
import { PageWrapperLinks } from '../../../theme/GlobalCss'
import ItemCatalogDetailBlock from './Components/ItemCatalogDetailBlock'
import ItemCatalogDetailPrice from './Components/ItemCatalogDetailPrice'
import ItemCatalogDetailConsignment from './Components/ItemCatalogDetailConsignment'
//////ASSETS//////
import noImage from '../../../assets/icones/global/no-picture.svg'
import { useRouteMatch } from 'react-router'

//////STYLED//////
const Wrapper = styled.div`
	position: relative;
	font-size: ${(props) => props.theme.font.fs};
`
const DistributionGroupRepositoryDetailWrapper = styled.div`
	display: grid;
	grid-template-rows: 20px auto auto 1fr;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 60px;
	grid-template-areas:
		'header header'
		'leftSide rightSide'
		'accessories accessories'
		'footer footer';
`
const DistributionGroupHeader = styled.div`
	grid-area: header;
	display: flex;
	align-items: center;
	margin-bottom: 30px;
`
const TitlePrimary = styled.div`
	width: 100%;
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
	font-size: ${(props) => props.theme.font.fm};
`
const DistributionGroupLeftSide = styled.div`
	grid-area: leftSide;
	display: flex;
`
const ImgWrapper = styled.div`
	max-height: 398px;
	width: 302px;
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	margin-right: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
`
const ImgItem = styled.img`
	max-height: 399px;
	max-width: 302px;
`
const DescWrapper = styled.div`
	height: 399px;
	width: 523px;
	display: flex;
	flex-direction: column;
`
const TopDescWrapper = styled.div`
	height: 50%;
	max-width: 100%;
`
const TopTextDescWrapper = styled.div`
	display: grid;
	row-gap: 10px;
`
const TopTextDescWrapperRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
`
const TopTextDescWrapperRowDescription = styled.div`
	grid-template-columns: 1fr;
`
const TopTextDescWrapperColumn = styled.div``

const TextWrapper = styled.div`
	font-weight: bold;
`
const BottomDescWrapper = styled.div`
	height: 50%;
	max-width: 100%;
	border: 1px solid ${(props) => (!isEmpty(props.itemContent) ? (props) => props.theme.colors.TabNav.border : 'none')};
	padding: 0 10px;
`
const TableDesc = styled.table`
	width: 100%;
	height: 100%;
`
const TrDesc = styled.tr`
	width: 50%;
	height: auto;
`
const TdLeft = styled.td`
	width: 30%;
	height: auto;
	tex-align: left;
	font-weight: bold;
	margin-left: 15px;
`
const TdRight = styled.td`
	width: 70%;
	height: auto;
	tex-align: left;
`
const AccessoriesWrapper = styled.div`
	max-height: auto;
	max-width: 827px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-auto-rows: auto;
	margin-top: 15px;
`
const AccessoriesItemWrapper = styled.div`
	max-height: 240px;
	max-width: auto;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin-bottom: 10px;
`
const AccessoriesItemImg = styled.img`
	max-height: 180px;
	max-width: 180px;
`
const AccessoriesItemImgWrapper = styled.div`
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	width: 160px;
	padding: 0 15px;
	margin-bottom: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
`
const AccessoriesItemText = styled.div``

const AccessoriesItemPrice = styled.div`
	font-weight: bold;
	color: ${(props) => props.theme.colors.primary};
	text-align: center;
`
const TitlePrimaryCustom = styled(TitlePrimary)`
	text-align: center;
`
const DistributionGroupAccessories = styled.div`
	grid-area: accessories;
	margin-top: 35px;
`
const DistributionGroupRightSide = styled.div`
	grid-area: rightSide;
	display: flex;
	flex-direction: column;
`
const TabDetailWrapper = styled.div`
	height: 45px;
	width: 100%;
	display: flex;
	flex-direction: row;
`
const TabItem = styled.div`
	height: 45px;
	width: 191px;
	background-color: ${(props) => props.theme.colors.TabNav.border};
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	color: ${(props) => props.theme.text.colors.primary};
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 15px;
	cursor: pointer;
`
const TabItemActive = styled.div`
	height: 45px;
	width: 191px;
	background-color: ${(props) => props.theme.colors.white};
	border-top: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-left: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-right: 1px solid ${(props) => props.theme.colors.TabNav.border};
	color: ${(props) => props.theme.text.colors.primary};
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 15px;
	cursor: pointer;
`
const DetailText = styled.div`
	min-height: ${(props) => (props.type == 'desc' ? '278px' : '352px')};
	max-height: ${(props) => (props.type == 'desc' ? '278px' : '352px')};
	width: 659px;
	border-bottom: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-top: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-left: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-right: 1px solid ${(props) => props.theme.colors.TabNav.border};
	display: ${(props) => (props.type == 'desc' ? 'grid' : 'flex')};
	align-items: center;
	justify-content: center;
	padding-top: ${(props) => (props.type == 'desc' ? '37px' : '0px')};
	padding-bottom: ${(props) => (props.type == 'desc' ? '37px' : '0px')};
	padding-left: 37px;
	padding-right: 37px;
	overflow-y: ${(props) => (props.type == 'desc' ? 'auto' : 'hidden')};
`
const UsageWrapper = styled.div`
	display: grid;
	grid-template-rows: repeat(auto, 2fr);
	grid-template-columns: repeat(3, 2fr);
	grid-column-gap: 45px;
	grid-row-gap: 45px;
`
const UsageItemWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
const UsageDescription = styled.div``
const DistributionGroupFooter = styled.div`
	grid-area: footer;
`
//////STYLED//////

const ItemCatalogDetail = () => {
	let history = useHistory()

	const [target, setTarget] = useState('desc')
	const match = useRouteMatch()

	const { translations, itemCatalogDetail } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			itemCatalogDetail: state.itemCatalogDetail.itemsDetail,
		}),
		shallowEqual
	)
	const actionsItemCatalogDetail = bindActionCreators(itemCatalogDetailActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleTab = (target) => {
		setTarget(target)
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (isEmpty(translations)) return
		if (!isUndefined(match.params.id)) {
			actionsItemCatalogDetail.getItemCatalogDetail(match.params.id)
		}
	}, [match.params.id, translations])

	useEffect(() => {
		return function cleanUp() {
			actionsItemCatalogDetail.resetItemCatalogDetail()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	/////////////////////////////// RENDER //////////////////////////////////////

	return (
		<Fragment>
			<Wrapper>
				<PageWrapperLinks>
					<Button
						goBack
						weight="bold"
						actionHandler={() => {
							history.goBack()
						}}
						text={translations['common__text__previousPage']}
					/>
				</PageWrapperLinks>
				<DistributionGroupRepositoryDetailWrapper>
					<DistributionGroupHeader>
						<TitlePrimary>{`${translations['page__itemCatalog__kiosk_detail__page_title']} ${
							!isUndefined(itemCatalogDetail) && itemCatalogDetail?.label
						}`}</TitlePrimary>
					</DistributionGroupHeader>
					<DistributionGroupLeftSide>
						<ImgWrapper>
							<ImgItem
								src={
									!isUndefined(itemCatalogDetail) && itemCatalogDetail?.picture !== null
										? `/${itemCatalogDetail?.picture}`
										: noImage
								}
							/>
						</ImgWrapper>
						<DescWrapper>
							<TopDescWrapper>
								<TopTextDescWrapper>
									<TopTextDescWrapperRow>
										<TopTextDescWrapperColumn>
											<TitlePrimary>{!isUndefined(itemCatalogDetail) && itemCatalogDetail?.brand}</TitlePrimary>
										</TopTextDescWrapperColumn>
										<TopTextDescWrapperColumn>
											<ItemCatalogDetailBlock target="stock" ItemDetail={itemCatalogDetail} translations={translations} />
										</TopTextDescWrapperColumn>
									</TopTextDescWrapperRow>
									<TopTextDescWrapperRow>
										<TopTextDescWrapperColumn>
											<TextWrapper>{!isUndefined(itemCatalogDetail) && itemCatalogDetail.label}</TextWrapper>
										</TopTextDescWrapperColumn>
										<TopTextDescWrapperColumn>
											<ItemCatalogDetailBlock target="promo" ItemDetail={itemCatalogDetail} translations={translations} />
										</TopTextDescWrapperColumn>
									</TopTextDescWrapperRow>
									<TopTextDescWrapperRowDescription>
										<TextWrapper>{!isUndefined(itemCatalogDetail) && itemCatalogDetail.shortDescription}</TextWrapper>
									</TopTextDescWrapperRowDescription>
									<TopTextDescWrapperRow>
										<TopTextDescWrapperColumn>
											{itemCatalogDetail?.promo ? (
												<ItemCatalogDetailPrice target="withPromo" ItemDetail={itemCatalogDetail} />
											) : (
												<ItemCatalogDetailPrice ItemDetail={itemCatalogDetail} />
											)}
										</TopTextDescWrapperColumn>
										<TopTextDescWrapperColumn />
									</TopTextDescWrapperRow>
									<TopTextDescWrapperRow>
										<TopTextDescWrapperColumn>
											{itemCatalogDetail?.withDeposit && (
												<ItemCatalogDetailConsignment ItemDetail={itemCatalogDetail} translations={translations} />
											)}
										</TopTextDescWrapperColumn>
									</TopTextDescWrapperRow>
								</TopTextDescWrapper>
							</TopDescWrapper>
							<BottomDescWrapper itemContent={itemCatalogDetail?.itemFeatures}>
								<TableDesc>
									{!isUndefined(itemCatalogDetail) &&
										map(itemCatalogDetail.itemFeatures, (elem, id) => (
											<TrDesc>
												<TdLeft>{`${translations[elem.translationKey]} :`}</TdLeft>
												<TdRight>{elem.value}</TdRight>
											</TrDesc>
										))}
								</TableDesc>
							</BottomDescWrapper>
						</DescWrapper>
					</DistributionGroupLeftSide>
					<DistributionGroupRightSide>
						<TabDetailWrapper>
							{target === 'desc' ? (
								<TabItemActive onClick={() => handleTab('desc')}>
									{translations['page__itemReferential__detail__subTab_description']}
								</TabItemActive>
							) : (
								<TabItem onClick={() => handleTab('desc')}>
									{translations['page__itemReferential__detail__subTab_description']}
								</TabItem>
							)}
							{target === 'usage' ? (
								<TabItemActive onClick={() => handleTab('usage')}>
									{translations['page__itemReferential__detail__subTab_usage']}
								</TabItemActive>
							) : (
								<TabItem onClick={() => handleTab('usage')}>{translations['page__itemReferential__detail__subTab_usage']}</TabItem>
							)}
						</TabDetailWrapper>
						{target === 'desc' && (
							<DetailText type={target}>{!isUndefined(itemCatalogDetail) && itemCatalogDetail.longDescription}</DetailText>
						)}
						{target === 'usage' && (
							<DetailText type={target}>
								<UsageWrapper>
									{!isUndefined(itemCatalogDetail) &&
										map(itemCatalogDetail.usages, (elem, id) => {
											const pic = find(usagePicsConfig, { id: elem.id })
											return (
												<UsageItemWrapper>
													<img src={isUndefined(pic) ? noImage : pic.picture} width={50} />
													<UsageDescription>{translations[elem.translationKey]}</UsageDescription>
												</UsageItemWrapper>
											)
										})}
								</UsageWrapper>
							</DetailText>
						)}
					</DistributionGroupRightSide>
					<DistributionGroupAccessories>
						<TitlePrimary>{translations['page__itemReferential__detail__header__accessories']} :</TitlePrimary>
						<AccessoriesWrapper>
							{!isUndefined(itemCatalogDetail) &&
								map(itemCatalogDetail.accessories, (elem, id) => (
									<AccessoriesItemWrapper>
										<AccessoriesItemImgWrapper>
											{isNull(elem.picture) ? (
												<AccessoriesItemImg src={noImage} />
											) : (
												<AccessoriesItemImg src={`/${elem.picture}`} />
											)}
										</AccessoriesItemImgWrapper>
										<AccessoriesItemText>
											<TitlePrimaryCustom>{elem.brand}</TitlePrimaryCustom>
											<TitlePrimaryCustom>{elem.label}</TitlePrimaryCustom>
										</AccessoriesItemText>
									</AccessoriesItemWrapper>
								))}
						</AccessoriesWrapper>
					</DistributionGroupAccessories>
					<DistributionGroupFooter></DistributionGroupFooter>
				</DistributionGroupRepositoryDetailWrapper>
			</Wrapper>
		</Fragment>
	)
}

export default ItemCatalogDetail
